import { render, staticRenderFns } from "./OutreachLogsView.vue?vue&type=template&id=79991b84&"
import script from "./OutreachLogsView.vue?vue&type=script&lang=js&"
export * from "./OutreachLogsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports